<template>
  <div>
    <div id="func-content">
      <b-card class="mb-2">
        <p style="text-align:right"><button type="button" class="btn btn-warning btnByEdit" v-show='FunctionPermission > 1' @click="edit2()">平假日編輯</button></p>
        <v-calendar
          class="custom-calendar max-w-full"
          style="width:100%"
          :masks="masks"
          :attributes="attributes"
          disable-page-swipe>
          <div
            slot="day-content"
            slot-scope="{ day, attributes }"
            class="flex flex-col h-full z-10 overflow-hidden"
            style="text-align:center"
          >
            <span class="day-label text-sm text-gray-900">{{ day.day }}</span>
            <div class="flex-grow overflow-y-scroll overflow-x-auto">
              <p v-for="(attr, key) in attributes" :key="key"
                class="text-xs leading-tight rounded-sm p-1 mt-0 mb-1 text-white"
                :class="{ bgblue: attr.customData.Weekday, bgred: attr.customData.Holiday }">
                {{ attr.customData.Memo }}
              </p>
            </div>
          </div>
        </v-calendar>

        <b-modal ref="mdEdit" :no-close-on-backdrop="true" hide-footer title="全國平/假日編輯" size="lg">
          <div class="d-block">
            <div class="col-lg-12 col-12 mb-3">
              <div class="row col-lg-12" style="padding-top:10px">
                <label class="control-label col-md-2">日期：</label>
                                      <div class="col-md-4">
                                          <input type="date" class="form-control" v-model="sdate" max="9999-12-31" :min='min_date' @change="onchange">
                                          <div class="text-danger" v-if="valid_sdate">{{valid_sdate}}</div>
                                      </div>
                                      <label class="control-label">至</label>
                                      <div class="col-md-4">
                                          <input type="date" class="form-control" v-model="edate" max="9999-12-31" :min='min_date'>
                                          <div class="text-danger" v-if="valid_edate">{{valid_edate}}</div>
                                      </div>
              </div>
              <div class="row col-lg-12" style="padding-top:10px">
                                      <div class="col-md-2">
                                          <label class="control-label">模式：</label>
                                      </div>
                                      <div class="col-md-10">
                                          <select class="form-control" v-model="mode" >
                                              <option value=0>無</option>
                                              <option value=1>平日</option>
                                              <option value=2>假日</option>
                                          </select>
                                      </div>
              </div>
              <div class="row col-lg-12" style="padding-top:10px">
                                      <div class="col-md-2">
                                          <label class="control-label">備註：</label>
                                      </div>
                                      <div class="col-md-10">
                                          <input type='text' name='Input_Memo' class='form-control' v-model.trim='memo' placeholder='請輸入備註' maxlength="30" >
                                      </div>
              </div>
            </div>
            <div class="cog-lg-12">
                <div class="row float-right cog-lg-12">
                    <b-btn class="mt-3" variant="primary"  @click="check2()">儲存</b-btn>&nbsp;
                    <b-btn class="mt-3"  variant="secondary"  @click="cancel2()">取消</b-btn>&nbsp;
                </div>
            </div>
          </div>
        </b-modal>
        <!--Double Check Modal -->
        <b-modal ref="mdCancelCheck" hide-footer title="取消訂單提醒">
        <b-container fluid>
          <form>
            <div class="row mb-3">
              <label class="control-label">提醒您，變更平假日模式會影響營業時間，<br /><b>當日</b>非營業時間訂單須由<font style="color:red">人員手動執行退貨</font>；<br />
                <b>非當日</b>且非營業時間的訂單由<font style="color:red">系統執行自動取消</font>。<br />確定要修改 ?</label>
            </div>
            <div class="float-right">
              <b-btn variant="primary" @click="save2()">確定</b-btn>
              <b-btn variant="secondary" @click="closeCancelCheck()">取消</b-btn>
            </div>
          </form>
        </b-container>
      </b-modal>
      </b-card>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import {API_URL} from '../../../store/root.js'
import { getFunctionPermission } from '@/js/LoginUserFunction.js'
import miniToastr from 'mini-toastr'
import Vue from 'vue'
import VCalendar from 'v-calendar'
miniToastr.init()
Vue.use(VCalendar)
export default {
  data () {
    return {
      FunctionPermission: '',
      // 日曆開始
      masks: {
        weekdays: 'WWW'
      },
      attributes: [
        {
          key: 1,
          customData: {
            Memo: '',
            Weekday: '',
            Holiday: ''
          },
          dates: ''
        }
      ],
      // 平假日編輯
      min_date: '', // 可選的最小日期
      mode: 0,
      memo: '',
      sdate: '',
      edate: '',
      valid_errMsg: false,
      valid_sdate: '',
      valid_edate: ''
    }
  },
  created () {
    this.FunctionPermission = getFunctionPermission('F20') // 功能權限
    if (this.FunctionPermission < 1) {
      this.$router.push({ name: 'name' })
      return
    }
    this.query()
    this.setdate()
  },
  methods: {
    setdate () {
      var date = new Date()
      var year = date.getFullYear()
      var mon = date.getMonth() + 1
      var day = date.getDate() + 1

      if (mon < 10) {
        mon = '0' + mon
      }
      if (day < 10) {
        day = '0' + day
      }
      this.min_date = year + '-' + mon + '-' + day
    },
    query () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/getOrderSettingWork/v1', {
        mode: 'workMode'
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            this.item = response.data.data
            this.attributes = this.item.list
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '商品資料讀取異常')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '商品資料讀取異常')
          console.log(error)
        })
    },
    edit2 () {
      this.$refs.mdEdit.show()
    },
    cancel2 () {
      this.$refs.mdEdit.hide()
      this.default2()
    },
    default2 () {
      this.mode = 0
      this.memo = ''
      this.sdate = ''
      this.edate = ''
      this.valid_sdate = ''
      this.valid_edate = ''
    },
    check2 () {
      this.valid_errMsg = false
      if (!this.sdate) {
        this.valid_errMsg = true
        this.valid_sdate = '日期(起)為必填'
      } else {
        if (this.sdate < this.min_date) {
          this.valid_errMsg = true
          this.valid_sdate = '起始日不可為今天(含)以前'
        } else {
          this.valid_sdate = ''
        }
      }
      if (!this.edate) {
        this.valid_errMsg = true
        this.valid_edate = '日期(迄)為必填'
      } else {
        if (this.sdate > this.edate) {
          this.valid_errMsg = true
          this.valid_edate = '起始日不可大於結束日'
        } else {
          this.valid_edate = ''
        }
      }

      if (this.valid_errMsg) {
        this.$parent.$parent.verificationErrMsg()
        return
      }
      this.$refs.mdCancelCheck.show()
    },
    save2 () {
      this.$refs.mdEdit.hide()
      this.$refs.mdCancelCheck.hide()
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/orderModeUpdate/v1', {
        mode: Number(this.mode),
        memo: this.memo,
        sdate: this.sdate,
        edate: this.edate
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)

          if (response.data.result === '0000') {
            miniToastr.success('儲存成功')
            this.query()
            this.default2()
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料變更錯誤')
            console.log(response.data.message)
            this.default2()
          }
        })
        .catch((error) => {
          miniToastr.error(error, '資料變更錯誤')
          console.log(error)
          this.default2()
        })
        .finally(() => {
          this.set_activity = false
          this.$parent.Loading = false
        })
    },
    onchange () {
      this.edate = this.sdate
    },
    closeCancelCheck () {
      this.$refs.mdCancelCheck.hide()
    }
  }
}
</script>

<style lang="postcss" scoped>
.bgblue {
    background-color: #107acc;
}
.bgred {
    background-color: #cc1010;
}

.btnByEdit, .btnByEdit:active, .btnByEdit:focus {
  color: #fff !important;
  background-color: #519B39 !important;
  border-color: #519B39 !important;
}

.btnByEdit:hover {
  color: #fff !important;
  background-color: #138045 !important;
  border-color: #138045 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/shopping/ordersetting/DayTypeSetting.vue